import AppContext from "PFApp/app_context";
import { usePage } from "PFApp/use_page";
import { fetchPaginatedCollection } from "PFCore/helpers/collection";
import { GROWL_ACTIONS } from "PFCore/reducers/growl_reducer";
import { ApiRoute } from "PFCore/utilities/routes";
import { useContext, useEffect } from "react";

export const useActivityTemplatesListPage = (initPage, accountId) => {
  const { page, setPage, mergePage, resetPage } = usePage(`features`, initPage);
  const { dispatch } = useContext(AppContext);

  const fetch = (page = 1, perPage = 50) =>
    fetchPaginatedCollection(ApiRoute(`/api/templates`), {
      account_id: accountId,
      page,
      perPage,
      apiVersion: 2
    })
      .then((response) =>
        mergePage({
          activityTemplates: {
            loaded: true,
            collection: response.entries
          }
        })
      )
      .catch(() =>
        mergePage({
          loaded: true,
          errors: ["there was an error"]
        })
      );

  const fetchAccount = () =>
    $.ajax({
      url: ApiRoute(`/api/saas_admin/accounts/${accountId}`)
    })
      .then(({ name }) =>
        mergePage({
          account: {
            loaded: true,
            name
          }
        })
      )
      .catch(() =>
        mergePage({
          loaded: true,
          errors: ["there was an error"]
        })
      );

  const toggleActivityTemplate = (activityTemplateId, state) =>
    $.ajax({
      url: ApiRoute(`/api/templates/${activityTemplateId}/${state ? "activate" : "deactivate"}`),
      method: "PUT",
      api_version: 2,
      headers: { "Content-Type": "application/json" },
      data: JSON.stringify({ account_id: accountId })
    })
      .then((response) => {
        const updatedActivityTemplates = [...page.activityTemplates.collection];
        const updatedIndex = updatedActivityTemplates.findIndex((f) => f.id === response.id);
        updatedActivityTemplates[updatedIndex] = response;

        mergePage({
          activityTemplates: {
            loaded: true,
            collection: updatedActivityTemplates
          }
        });

        return response;
      })
      .then((response) => {
        const type = GROWL_ACTIONS.GROWL_RENDER;

        dispatch({
          type,
          payload: { message: `Template toggled ${response.active ? "on" : "off"}`, kind: "success" }
        });
      })
      .catch((errs) => {
        const response = errs.responseJSON;
        const type = GROWL_ACTIONS.GROWL_RENDER;

        response.errors.forEach((error) => {
          dispatch({ type, payload: { message: error.detail, kind: "error" } });
        });
      });

  useEffect(() => {
    setPage(initPage);
    return resetPage;
  }, []);

  useEffect(() => {
    fetchAccount();
    fetch();
  }, []);

  return { ...page, fetch, toggleActivityTemplate };
};
